import { Sparkles } from "lucide-react";

const items = [
  "KNOWLEDGE IS POWER",
  "REAL-TIME MULTIPLAYER",
  "DAILY TRIVIA DUELS",
  "UNLOCK EPIC BADGES",
  "ANDROID EXCLUSIVE",
  "FREE TO PLAY",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((t) => (
      <span key={t} className="flex items-center">
        <span className="font-display px-8 text-sm font-bold tracking-[0.2em] text-[#94A3B8]">
          {t}
        </span>
        <Sparkles size={14} className="text-[#00F0FF]" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="relative overflow-hidden border-y border-[#222738] bg-[#0F111A]/60 py-5">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
